export default __webpack_public_path__ + "static/media/wLogo.568c61a1.jpeg";